<div
  class="filter-container"
  [ngClass]="{
    popCalender: filterOptions == null,
    'right-justify': rightJustify,
  }"
>
  <div class="filter-content date">
    <h2 class="filter-calender-title">Please select {{ filterTitle | lowercase }} range.</h2>
    @if (!enterDateManually) {
      <div>
        <ngb-datepicker class="filter-calendar" #dp navigation="arrows" (dateSelect)="onDateSelection($event)" [displayMonths]="2" [outsideDays]="outsideDays" [minDate]="minimumDate" [maxDate]="maximumDate" [dayTemplate]="t" [firstDayOfWeek]="0">
        </ngb-datepicker>
        <ng-template #t let-date let-focused="focused">
          <span class="custom-day" [class.focused]="focused" [class.range]="isRange(date)" [class.faded]="isHovered(date) || isInside(date)" (mouseenter)="hoveredDate = date" (mouseleave)="hoveredDate = null">
            {{ date.day }}
          </span>
        </ng-template>
        <button type="button" class="manual-toggle-btn no-border-btn btn-link font-regular font-light nounderline cursor-pointer" (click)="enterDateManually = true">Enter dates manually</button>
      </div>
    }

    @if (enterDateManually) {
      <div>
        <div class="date-range">
          <form [formGroup]="dateRangeForm" novalidate>
            <mat-form-field appearance="fill" id="startDate">
              <mat-label>Start date</mat-label>
              <input
                required
                matInput
                class="input-date"
                formControlName="selectedDate"
                placeholder="MM/DD/YYYY"
                [minDate]="minimumDate"
                [navigation]="datePickerSettings.navigation"
                [maxDate]="maximumDate"
                ngbDatepicker
                [firstDayOfWeek]="0"
                #d="ngbDatepicker"
                [outsideDays]="outsideDays"
                (keypress)="onKeyPress($event)"
              />
              <a tabindex="0" role="button" (keyup.enter)="$event.target.click()" class="date-icon" (click)="d.toggle()" aria-label="Select Date">
                <i class="icon-date-range" aria-hidden="true"></i>
              </a>
              @if (dateRangeForm.get('selectedDate').errors) {
                <mat-error data-cy="start-date-error">
                  <ng-container *ngTemplateOutlet="errorsTemplate; context: { $implicit: this.ngbDateErrors('selectedDate') }"></ng-container>
                </mat-error>
              }
            </mat-form-field>
            <mat-form-field appearance="fill" id="endDate" class="end-date-picker">
              <mat-label>End date</mat-label>
              <input
                matInput
                class="input-date"
                formControlName="selectedEndDate"
                placeholder="MM/DD/YYYY"
                [minDate]="minimumDate"
                [maxDate]="maximumDate"
                [navigation]="datePickerSettings.navigation"
                ngbDatepicker
                [firstDayOfWeek]="0"
                #d1="ngbDatepicker"
                [outsideDays]="outsideDays"
                (keypress)="onKeyPress($event)"
              />
              <a tabindex="0" role="button" (keyup.enter)="$event.target.click()" class="date-icon" (click)="d1.toggle()" aria-label="Select Date">
                <i class="icon-date-range" aria-hidden="true"></i>
              </a>
              @if (dateRangeForm.get('selectedEndDate').errors) {
                <mat-error data-cy="end-date-error">
                  <ng-container
                    *ngTemplateOutlet="
                      errorsTemplate;
                      context: {
                        $implicit: this.ngbDateErrors('selectedEndDate'),
                      }
                    "
                  ></ng-container>
                </mat-error>
              }
            </mat-form-field>
            @if (dateRangeForm.errors) {
              <mat-error style="padding-top: 2rem" data-cy="both-date-error">
                <ng-container *ngTemplateOutlet="errorsTemplate; context: { $implicit: this.formGroupErrors() }"></ng-container>
              </mat-error>
            }
          </form>
        </div>
        @if (enterDateManually) {
          <button type="button" class="manual-toggle-btn no-border-btn btn-link font-regular font-light nounderline cursor-pointer" (click)="backToCalendarView()">Back to Calendar View</button>
        }
      </div>
    }
  </div>
  <div class="filter-footer text-center">
    <button mat-flat-button class="mat-secondary" [disabled]="!canApplyFilter()" (click)="clearFilter()" id="clearFIlterPopup" data-cy="filter-popup-clear-button">Clear</button>
    <button data-cy="filter-popup-apply-button" mat-flat-button class="mat-primary" [disabled]="!canApplyFilter()" (click)="apply()" id="applyFIlterPopup">Apply</button>
  </div>
</div>

<ng-template #errorsTemplate let-errors>
  @for (errorTypes of errors; track errorTypes) {
    @if (errorTextObj[errorTypes]) {
      <span class="pb-3">
        <i class="icon-warning_white"></i>
        {{ errorTextObj[errorTypes] }}
      </span>
    }
  }
</ng-template>
